export const formatCurrency = (value: string | number, symbol = 'R$') => {
    if (!value) return null;
    if (isNaN(Number(value))) return value;
    const value_string = Number(value).toFixed(2).replace('.', ',');
    const currency_string = `${symbol}${value_string}`;
    return currency_string;
};
